<div class="auth-shell">
  <div class="auth-card">
    <section class="brand-panel">
      <div class="brand-mark">
        <span class="brand-logo" aria-hidden="true">
          <img [src]="brand.logoPath" alt="" />
        </span>
        <span class="brand-name">{{ brand.name }}</span>
      </div>
      <h1>Welcome back to the control room</h1>
      <p>
        Track performance, align teams, and ship milestones faster. Login to continue
        managing your workspace.
      </p>
      <div class="feature-list">
        <div class="feature">
          <mat-icon>dashboard</mat-icon>
          <span>Live KPI dashboards</span>
        </div>
        <div class="feature">
          <mat-icon>shield</mat-icon>
          <span>Secure access for every role</span>
        </div>
        <div class="feature">
          <mat-icon>auto_graph</mat-icon>
          <span>Growth insights in real time</span>
        </div>
      </div>
    </section>

    <section class="form-panel">
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Login</mat-card-title>
          <mat-card-subtitle>Use your phone number and password.</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <form class="form-grid" [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <div class="phone-row">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country</mat-label>
                <mat-select formControlName="countryCode">
                  <mat-option value="+1">
                    <span class="country-option">
                      <span class="flag flag-us" aria-hidden="true"></span>
                      <span>US +1</span>
                    </span>
                  </mat-option>
                  <mat-option value="+44">
                    <span class="country-option">
                      <span class="flag flag-uk" aria-hidden="true"></span>
                      <span>UK +44</span>
                    </span>
                  </mat-option>
                  <mat-option value="+61">
                    <span class="country-option">
                      <span class="flag flag-au" aria-hidden="true"></span>
                      <span>AU +61</span>
                    </span>
                  </mat-option>
                  <mat-option value="+65">
                    <span class="country-option">
                      <span class="flag flag-sg" aria-hidden="true"></span>
                      <span>SG +65</span>
                    </span>
                  </mat-option>
                  <mat-option value="+91">
                    <span class="country-option">
                      <span class="flag flag-in" aria-hidden="true"></span>
                      <span>IN +91</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Phone number</mat-label>
                <input matInput formControlName="phone" placeholder="9876543210" />
                <mat-hint>10 digits only</mat-hint>
                @if(loginForm.get('phone')?.hasError('required')){
                 <mat-error>
                   Phone number is required.
                 </mat-error>
                }
                @if(loginForm.get('phone')?.hasError('pattern')){
                  <mat-error>
                    Please enter a valid phone number.
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input
                matInput
                [type]="hidePassword() ? 'password' : 'text'"
                formControlName="password"
                placeholder="Minimum 8 characters"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                aria-label="Toggle password visibility"
                (click)="togglePassword()"
              >
                <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              @if(loginForm.get('password')?.hasError('required')){
                <mat-error>
                  Password is required.
                </mat-error>
              }
              @if(loginForm.get('password')?.hasError('minlength')){
                 <mat-error>
                  Use at least 8 characters.
                </mat-error>
              }
            </mat-form-field>

            @if(validationError()){
            <app-validation-error [errors]="validationError()"></app-validation-error>
            }

            <div class="form-actions">
              <button mat-raised-button color="primary" type="submit">Log in</button>
              
              <button mat-button type="button" routerLink="/auth/forgot-password">Forgot password?</button>
            </div>
          </form>
          <mat-divider class="section-divider"></mat-divider>
          <!-- <div class="footer-actions">
            <span>New to {{ brand.name }}?</span>
            <button mat-button type="button" routerLink="/auth/register">Create account</button>
          </div> -->
        </mat-card-content>
      </mat-card>
    </section>
  </div>
</div>
